import { React, useState } from 'react';
import { useNavigate } from "react-router-dom";
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from "react-i18next";
import { motion } from 'framer-motion';
import "./index.scss";

import ProfileAvatar from "../../../../components/ui/ProfileAvatar";
import MonitorModal from "../../../../components/PostLogin/Monitor/MonitorModal";

import { formatNumber, getDomainImageUrl } from "../../../../utils/util";
import SkeletonLoader from "../../../ui/SkeletonLoader";


const MonitorTileView = ({monitorList, isLoading}) => {

    const { t } = useTranslation();

    const navigate = useNavigate()

    const [showDeleteModal, setShowDeleteModal] = useState(false);

    // const handleShowModal = () => {
    //     setShowDeleteModal(true); // Open the modal
    // };
    
    const handleCloseModal = () => setShowDeleteModal(false);

    const secondaryText = (data) => {
        let scanType = data?.scan_type === "active" ? "Active Scan" : "Passive Scan"
        return `${scanType} | ${data.monitor_type}`
    }

    return (
        <>
            <Row>
                {
                    isLoading ?
                        <Col xl="12" lg="12" md="12">
                            <div className="monitor-container px-4 py-3 rounded">
                                <SkeletonLoader type={"line"} count={3} currentPage={"monitor"} />
                            </div>
                        </Col>                    
                    :
                    <>
                        {
                            monitorList?.results.length > 0 &&
                            monitorList?.results.map((data, index) => {
                                return (
                                    <Col xl="6" lg="12" md="12" className="col-xxxl-4 mb-4" key={index}>
                                        <motion.div
                                            key={index}
                                            initial={{ opacity: 0, y: 20 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            // whileInView={{ opacity: 1, y: 0 }}
                                            // viewport={{ once: true }}
                                            transition={{ duration: 0.4, delay: index * 0.1 }}
                                        >
                                            <div className="monitor-container px-4 py-3 rounded">
                                                <div className="organization-profile">
                                                    <div className="d-flex justify-content-between align-items-center">
                                                        <div className="organization-details">
                                                            <ProfileAvatar type="profile" secondaryText={secondaryText(data)} firstName={data?.monitor_domain?.domain} imageUrl={getDomainImageUrl(data?.monitor_domain)} />
                                                        </div>
                                                        <div className="organization-actions">
                                                            {/* <button
                                                                className="view-profile-btn"
                                                                onClick={handleShowModal}
                                                            >
                                                                {t("monitor.editBtn")}
                                                            </button> */}
                                                            <button
                                                                className="view-profile-btn"
                                                                onClick={()=>{navigate(`/monitor/details/${data.monitor_id}`)}}
                                                            >
                                                                Manage
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="user-scan-details mt-4">
                                                    <Row>
                                                        <Col lg={6}>
                                                            <div className="scan-count p-3">
                                                                <p className="label">{t('monitor.active')}</p>
                                                                <p className="value">{formatNumber(data?.stats?.scans?.active)}</p>
                                                            </div>
                                                        </Col>
                                                        <Col lg={6}>
                                                            <div className="scan-count p-3">
                                                                <p className="label">{t('monitor.passive')}</p>
                                                                <p className="value">{formatNumber(data?.stats?.scans?.passive)}</p>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                            </div>
                                        </motion.div>                                        
                                    </Col>
                                )
                            })
                        }
                    </>
                }                
                <MonitorModal show={showDeleteModal} onHide={handleCloseModal} />
            </Row>
        </>
    )
}

export default MonitorTileView;